<form class="form-horizontal form-material" [formGroup]="registerForm" (ngSubmit)="onSubmit()" #formDir="ngForm">
    <div *ngIf="!isVerificationSuccess">

        <!-- Phone -->
        <div>
            <app-phone-input [formGroup]="registerForm" [label]="'Teléfono celular'" (change)="onPhoneChange($event)" (blur)="onCheckPhone()">
            </app-phone-input>
            <div *ngIf="phoneDuplicated">
                <!-- Ya tiene cuenta registrada  -->
                <div class="has-danger" style="margin: -16px 0 0 0;">
                    <div class="form-control-feedback">
                        <small>
                            Este teléfono ya está vinculado a una cuenta
                        </small>
                    </div>
                    <div (click)="onContact()" style="margin: 0 0 16px 0;">
                        <a class="cursor-pointer font-12">
                            Si creés que alguien utilizó tu número, contactanos aquí.
                        </a>
                    </div>
                </div>
            </div>
            <!-- button verify sms -->
            <div class="form-group m-t-24 text-center">
                <button class="btn btn-primary w-100" type="button" [disabled]="isInvalid()" (click)="onVerifyPhone()">
                    Continuar
                </button>
            </div>
        </div>
    </div>

    <!-- El código de confirmación fue enviado y hay que verificarlo -->
    <div *ngIf="isVerificationSuccess">
        <div class="text-muted text-left font-c1 p-b-16">
            Enviado a:
            <b>{{phone.value?.dialCode}} {{phone.value?.number}}</b>
        </div>

        <app-code-input [formGroup]="registerForm" [onReset]="onReset"></app-code-input>
        <div *ngIf="codeAlert" class="has-danger">
            <small class="form-control-feedback text-primary">
                {{codeAlert}}
            </small>
        </div>

        <div class="m-t-24 text-center">
            <div class="text-muted font-b2">¿No recibiste el código al tu SMS?</div>
            <div class="m-t-10">
                <a class="font-b2 text-purple" href="javascript:void(0)" (click)="onVerifyPhone(true)">Volver a enviar</a>
            </div>
        </div>

        <!-- button submit crear cuenta -->
        <div class="form-group m-t-24 text-center">
            <button class="btn btn-primary btn-med w-100" type="submit" [disabled]="isInvalidCode()">Verificar</button>
        </div>
    </div>
</form>